import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';

import { CartService } from '../../core/services/cart.service';
import { ModalService } from '../../core/services/modal.service';
import { PlatformService } from '../../core/services/ssr/platform.service';

import { VendorChatExplainerModalPageAnimations } from './vendor-chat-explainer-modal.animations';

export const VendorChatExplainerModalIdentifier = 'vendor-chat-explainer-modal';

@Component({
  selector: 'app-vendor-chat-explainer-modal',
  templateUrl: 'vendor-chat-explainer-modal.page.html',
  styleUrls: ['vendor-chat-explainer-modal.page.scss'],
  animations: [...VendorChatExplainerModalPageAnimations],
  encapsulation: ViewEncapsulation.None,
})
export class VendorChatExplainerModalPage implements OnInit {
  @Input()
  public vendorName: string;

  public isBrowser: boolean;
  public cartItemsCount: number;

  constructor(private modalService: ModalService, private platformService: PlatformService, private cartservice: CartService) {}

  ngOnInit() {
    this.isBrowser = this.platformService.isBrowser;
    this.cartItemsCount = this.cartservice.getItemsCount();
  }

  public dismiss(): Promise<boolean> {
    return this.modalService.dismissModal({ id: VendorChatExplainerModalIdentifier });
  }
}
